import {ReactNode, useEffect} from 'react';
import {FullScreenModal} from '@/shared/components/ui/Modal';
import {UseModal} from '@/shared/hooks/useModal';

export default function DiagnosticReportFormModal({
  children,
  modal,
  title
}: {
  children: ReactNode;
  modal: UseModal;
  title: ReactNode;
}) {
  useEffect(
    function () {
      if (modal.isOpened) {
        window.scrollTo(0, 0);
      }
    },
    [modal.isOpened]
  );

  return (
    <FullScreenModal
      isOpened={modal.isOpened}
      onClose={modal.close}
      aria-labelledby={title}
      aria-describedby={title}
      title={title}
      id="diagnosticReportRequestFormModal"
    >
      {children}
    </FullScreenModal>
  );
}
